import { render, staticRenderFns } from "./NewDistributor.vue?vue&type=template&id=5cfb4902&scoped=true&"
import script from "./NewDistributor.vue?vue&type=script&lang=js&"
export * from "./NewDistributor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfb4902",
  null
  
)

export default component.exports